import { login } from './login';
import { loginOrRegister } from './loginOrRegister';
import { getPayments } from './getPayments';
import { getAddresses } from './getAddresses';
import { getEmailStatus } from './getEmailStatus';
import { resendEmailVerification } from './resendEmailVerification';
import { consumeVerificationCode } from './consumeVerificationCode';
import { getOrders } from './getOrders';
import { getOrder } from './getOrder';
import { getAppointments } from './getAppointments';
import { getMedcards } from './getMedcards';
import { getAppointmentsPackages } from './getAppointmentsPackages';
import { removePayment } from './removePayment';
import { confirmAppointment } from './confirmAppointment';
import { addAddress } from './addAddress';
import { updateUserProfile } from './updateUserProfile';
import { updateAddress } from './updateAddress';
import { removeAddress } from './removeAddress';
import { addPayment } from './addPayment';
import { getPets } from './getPets';
import { editPet } from './editPet';
import { addPets } from './addPets';
import { getPetVetClinics } from './getPetVetClinics';
import { getPetsConfig } from './getPetsConfig';
import { removePet } from './removePet';
import * as Client from './client';
import { updatePayment } from './updatePayment';
import {
    getCustomerBookingEligibility,
    getCustomerPetBookingEligibility,
} from './bookingEligibility';

export const AccountAPI = {
    getPets,
    addPets,
    editPet,
    removePet,
    getPetsConfig,
    getPetVetClinics,
    login,
    loginOrRegister,
    getPayments,
    getAddresses,
    getEmailStatus,
    getOrders,
    getOrder,
    removePayment,
    resendEmailVerification,
    consumeVerificationCode,
    getAppointments,
    getMedcards,
    getAppointmentsPackages,
    confirmAppointment,
    addAddress,
    updateUserProfile,
    updateAddress,
    removeAddress,
    addPayment,
    Client,
    updatePayment,
    getCustomerBookingEligibility,
    getCustomerPetBookingEligibility,
};
